let realUFunc = null;

function load() {
  return import(/*webpackChunkName:"core_ufunc_async"*/ "./customMathematical");
}

const ufunc = function (formula) {
  return load().then((res) => {
    let uf = dsf.getEsModule(res);
    return uf(formula);
  });
};
ufunc.compile = function (input, callback) {
  return new Promise((resolve, reject) => {
    return load()
      .then((res) => {
        let uf = dsf.getEsModule(res);
        var code = uf.compile(input, callback);
        resolve(code);
      })
      .catch((ex) => {
        reject(ex);
      });
  });
};
export default ufunc;
